// import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
// import {
//   Grid, TextField, Select, MenuItem, InputLabel, FormControl
// } from "@mui/material";
// import { useTheme } from "@mui/material/styles";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
// import { tokens } from "../../../../../theme";

// const PersonalDetails = forwardRef(({
//   employeeId = null,
//   setUpdatePersonalDetailsRef,
//   onChange,
//   handleFieldChange,
//   personalDetails = {}
// }, ref) => {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);

//   const isEdit = Boolean(employeeId);

//   const defaultValues = {
//     First_Name: "", Middle_Name: "", Last_Name: "", Legal_Name: "", 
//     Mobile_Number: "", Personal_Email_ID: "", Corporate_Email_ID: "", 
//     Blood_Group: "", Languages_Known: "", Tshirt_Size: "", 
//     Probationary_Period: "", Branch_ID: "", Gender: "", Marital_Status: "", 
//     Designation: "", Date_Of_Birth: "", Joining_Date: "", Resignation_Date: "", 
//     Releaving_Date: "", Status: ""
//   };

//   const [formData, setFormData] = useState(defaultValues);

//   const fetchPersonalDetails = async () => {
//     try {
//       const token = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/get-personal-details/${employeeId}`, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           "Authorization": `Bearer ${token}`
//         }
//       });

//       if (!response.ok) throw new Error("Fetch failed");
//       const data = await response.json();

//         if (data.status === "success" && data.personalDetails) {
//           const pd = data.personalDetails;
//           const normalized = {
//             ...defaultValues,
//             ...pd,
//             Designation: pd.Designation ?? pd.Designation ?? "",
//             Date_Of_Birth: pd.Date_Of_Birth ?? "-",
//             Releaving_Date: pd.Releaving_Date ?? "-",
//             Resignation_Date: pd.Resignation_Date ?? "-",
//             Probationary_Period: pd.Probationary_Period ?? 0,
//             Job_Title_ID: pd.Job_Title_ID ?? 0,
//             Blood_Group: pd.Blood_Group ?? "-",
//             // Add any other mappings if needed
//           };
//         setFormData(normalized);
//         if (onChange) onChange("personalDetails", normalized);
//       }
//     } catch (error) {
//       console.error("Error fetching personal details:", error);
//     }
//   };

//   useEffect(() => {
//     if (isEdit) fetchPersonalDetails();
//   }, [employeeId]);

//   useEffect(() => {
//     if (setUpdatePersonalDetailsRef) {
//       setUpdatePersonalDetailsRef(() => updatePersonalDetails);
//     }
//   }, []);

//   useEffect(() => {
//     if (personalDetails) {
//       setFormData((prev) => ({ ...prev, ...personalDetails }));
//     }
//   }, [personalDetails]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//     handleFieldChange("personalDetails", name, value);
//   };

//   const updatePersonalDetails = async () => {
//     const token = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;

//     const method = isEdit ? "PUT" : "POST";
//     const endpoint = isEdit
//       ? `/update-personal-details/${employeeId}`
//       : `/add-personal-details`;

//     try {
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}${endpoint}`, {
//         method,
//         headers: {
//           "Content-Type": "application/json",
//           "Authorization": `Bearer ${token}`
//         },
//         body: JSON.stringify(formData)
//       });

//       const result = await response.json();
//       if (result.status !== "success") {
//         console.log("Failed to submit personal details.");
//       }
//     } catch (error) {
//       console.error("Error submitting personal details:", error);
//     }
//   };

//   useImperativeHandle(ref, () => ({
//     savePersonal: updatePersonalDetails
//   }));

//   const selectOptions = {
//     Status: ["Active", "Inactive", "On Leave", "Resigned"],
//     Designation: ["Senior Engineer","Software Engineer", "DevOps Engineer", "FullStack Developer", "Fullstack Engineer","Team Lead", "HR", "Director", "Intern", "Manager","Python Developer","Backend Developer","Data Analyst","Flutter Developer"],
//     Gender: ["Male", "Female", "Other"],
//     Marital_Status: ["Single", "Married","Divorced"],
//     Blood_Group: ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"],
//     Tshirt_Size: ["XS", "S", "M", "L", "XL", "XXL"],
//     Branch_ID:["Pune","Ahmedabad"]
//   };

//   const dateFields = ["Date_Of_Birth", "Joining_Date", "Resignation_Date", "Releaving_Date"];
//   const allowedFields = Object.keys(defaultValues);

//   const customInputSx = {
//     borderRadius: "8px",
//     backgroundColor: "transparent",
//     "& .MuiOutlinedInput-notchedOutline": { borderColor: "#aaa" },
//     "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#aaa !important" },
//     "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#aaa !important" }
//   };

//   const customLabelSx = {
//     fontSize: "16.5px",
//     fontWeight: "bold",
//     color: colors.grey[100],
//     letterSpacing: "-0.5px",
//     "&.Mui-focused": { color: colors.grey[100] },
//     "&.MuiInputLabel-shrink": { color: colors.grey[100] }
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDateFns}>
//       <Grid container spacing={3}>
//         {allowedFields.map((key) => (
//           <Grid item xs={12} sm={6} md={4} key={key}>
//             {Object.keys(selectOptions).includes(key) ? (
//               <FormControl fullWidth>
//                 <InputLabel sx={customLabelSx}>{key.replace(/_/g, " ")}</InputLabel>
//                 <Select
//                   name={key}
//                   value={selectOptions[key].includes((formData[key] || "").trim()) ? formData[key].trim() : ""}
//                   onChange={handleChange}
//                   label={key.replace(/_/g, " ")}
//                   sx={customInputSx}
//                 >
//                   {selectOptions[key].map(option => (
//                     <MenuItem key={option} value={option}>{option}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             ) : dateFields.includes(key) ? (
//               <DatePicker
//                 label={key.replace(/_/g, " ")}
//                 value={formData[key] ? new Date(formData[key]) : null}
//                 onChange={(newDate) => {
//                   handleChange({
//                     target: {
//                       name: key,
//                       value: newDate ? newDate.toISOString().split("T")[0] : ""
//                     }
//                   });
//                 }}
//                 slotProps={{
//                   textField: {
//                     fullWidth: true,
//                     variant: "outlined",
//                     size: "medium",
//                     label: key.replace(/_/g, " "),
//                     InputProps: { sx: customInputSx },
//                     InputLabelProps: { sx: customLabelSx },
//                     sx: {
//                       width: "100%",
//                       "& .MuiOutlinedInput-root": {
//                         borderRadius: "8px",
//                         minHeight: "56px"
//                       },
//                       "& .MuiOutlinedInput-notchedOutline": {
//                         borderColor: "#aaa"
//                       },
//                       "&:hover .MuiOutlinedInput-notchedOutline": {
//                         borderColor: "#aaa !important"
//                       },
//                       "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//                         borderColor: "#aaa !important"
//                       },
//                       "& .MuiInputBase-input": {
//                         padding: "12.5px 14px",
//                         fontSize: "1rem"
//                       }
//                     }
//                   }
//                 }}
//               />
//             ) : (
//               <TextField
//                 fullWidth
//                 label={key.replace(/_/g, " ")}
//                 name={key}
//                 value={formData[key] || " "}
//                 onChange={handleChange}
//                 variant="outlined"
//                 size="medium"
//                 InputProps={{ sx: customInputSx }}
//                 InputLabelProps={{ sx: customLabelSx }}
//               />
//             )}
//           </Grid>
//         ))}
//       </Grid>
//     </LocalizationProvider>
//   );
// });

// export default PersonalDetails;


import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { Grid, TextField, FormControl, InputLabel, Select, MenuItem, useTheme } from "@mui/material";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { tokens } from "../../../../../theme";
import { useParams } from "react-router-dom";

const PersonalDetailsForm = forwardRef(({setUpdatePersonalDetailsRef, onChange, handleFieldChange, personalDetails }, ref) => {
    const { employeeId } = useParams();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const defaultValues = {
      First_Name: "", Middle_Name: "", Last_Name: "", Legalname: "",
      PersonalMobileNumber: "", Personal_EmailID: "", corporate_email_id: "",
      BloodGroup: "", languages_known: "", Tshirt_Size: "",
      Probationary_Period: "", branch_id: "", gender: "", marital_status: "",
      designation: "", date_of_birth: "", joining_date: "", Resignation_Date: "",
      Releaving_Date: "", isAdmin: "", status: "",employeeType:""
    };
    const requiredFields = [
      "First_Name",
      "Middle_Name",
      "Last_Name",
      "Legalname",
      "branch_id",
      "PersonalMobileNumber",
      "Personal_EmailID",
      "corporate_email_id",
      "gender",
      "date_of_birth",
      "joining_date",
      "designation",
      "isAdmin",
      "status"
    ];

    const [formData, setFormData] = useState({ corporate_email_id: "" });
    const [errors, setErrors] = useState({});

    const selectOptions = {
    gender: ["Male", "Female", "Other"],
    marital_status: ["Single", "Married", "Divorced"],
    designation: [
      "Senior Engineer", "Software Engineer", "DevOps Engineer", "FullStack Developer", 
      "Fullstack Engineer", "Team Lead", "HR", "Director", "Intern", "Manager",
      "Python Developer", "Backend Developer", "Data Analyst", "Flutter Developer"
    ],
    status: ["Active", "Inactive", "On Leave", "Resigned"],
    BloodGroup: ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"],
    Tshirt_Size: ["XS", "S", "M", "L", "XL", "XXL"],
    branch_id: ["Pune", "Ahmedabad"],
    isAdmin: ['true', 'false']
  };
  

    const dateFields = ["date_of_birth", "joining_date", "Resignation_Date", "Releaving_Date"];
    const normalizeBackendData = (data) => {
      return {
        First_Name: data.First_Name || "",
        Middle_Name: data.Middle_Name || "",
        Last_Name: data.Last_Name || "",
        Legalname: data.Legal_Name || "",

        PersonalMobileNumber: data.Mobile_Number || "",
        Personal_EmailID: data.Personal_Email_ID || "",
        corporate_email_id: data.Corporate_Email_ID || "",

        BloodGroup: data.Blood_Group || "",
        languages_known: data.Languages_Known || "",
        Tshirt_Size: data.Tshirt_Size || "",

        Probationary_Period: data.Probationary_Period || "",
        branch_id: data.Branch_ID || "",
        gender: data.Gender || "",
        marital_status: data.Marital_Status || "",

        designation: data.Designation?.trim() || "", // trim extra whitespace
        date_of_birth: formatDateString(data.Date_Of_Birth) || "", 
        joining_date: formatDateString(data.Joining_Date) || "",
        Resignation_Date: formatDateString(data.Resignation_Date) || "",
        Releaving_Date: formatDateString(data.Releaving_Date) || "",

        isAdmin: String(data.isAdmin) || "false",
        status: data.Status || "",
        employeeType: data.Employee_Type || "",
      };
    };

    const formatDateString = (dateStr) => {
      if (!dateStr || dateStr === 0) return "";
      const date = new Date(dateStr);
      if (isNaN(date)) {
        // Try parsing custom formats
        const parts = dateStr.split("-");
        if (parts.length === 3) {
          // e.g. "07-May-2001"
          const day = parts[0];
          const monthStr = parts[1];
          const year = parts[2];
          const monthMap = {
            Jan: "01", Feb: "02", Mar: "03", Apr: "04",
            May: "05", Jun: "06", Jul: "07", Aug: "08",
            Sep: "09", Oct: "10", Nov: "11", Dec: "12",
          };
          const month = monthMap[monthStr] || "01";
          return `${year}-${month}-${day.padStart(2, "0")}`;
        }
        return "";
      }
      return date.toISOString().split("T")[0];
    };


    const allowedFields = Object.keys(defaultValues);

    useEffect(() => {
      if (employeeId) {
        fetchPersonalDetails();
      }
      else {
        setFormData(defaultValues); 
      }
    }, [employeeId]);

    useEffect(() => {
      if (personalDetails) {
        setFormData(prev => {
          const newData = { ...prev, ...personalDetails };
          if (JSON.stringify(prev) !== JSON.stringify(newData)) {
            return newData;
          }
          return prev;
        });
      }
      else if (!employeeId) {
        setFormData(defaultValues);
      }
    }, [personalDetails, employeeId]);


    useEffect(() => {
      if (setUpdatePersonalDetailsRef) {
        setUpdatePersonalDetailsRef(() => (employeeId ? handleUpdate : handleSave));
      }
    }, [employeeId]);

    const fetchPersonalDetails = async () => {
      const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/get-personal-details/${employeeId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`
          }
        });

        const data = await res.json();
        if (data.status === "success" && data.personalDetails) {
          const normalized = normalizeBackendData(data.personalDetails);
          setFormData(normalized);
          if (JSON.stringify(formData) !== JSON.stringify(normalized)) {
            setFormData(normalized);
            onChange?.("personalDetails", normalized);
          }
        }
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };


    const handleDateChange = (key, newValue) => {
      const iso = newValue ? newValue.toISOString().split("T")[0] : "";
      setFormData(prev => ({ ...prev, [key]: iso }));
      handleFieldChange?.("personalDetails", key, iso);
      setErrors(prev => ({ ...prev, [key]: "" }));
    };

    const handleChange = (event) => {
      const { name, value } = event.target;

      setFormData(prev => ({ ...prev, [name]: value }));
      handleFieldChange?.("personalDetails", name, value);
      setErrors(prev => ({ ...prev, [name]: "" }));
    };

    const validateForm = () => {
      let newErrors = {};

      requiredFields.forEach((field) => {
        if (!formData[field]) {
          newErrors[field] = `${field.replace(/_/g, " ")} is required`;
        }
      });

      // Name fields validation
      ["First_Name", "Middle_Name", "Last_Name", "Legalname"].forEach((field) => {
        if (formData[field] && !/^[A-Za-z\s]+$/.test(formData[field])) {
          newErrors[field] = `${field.replace(/_/g, " ")} must contain only letters`;
        }
      });

      // Mobile Number
      if (formData.PersonalMobileNumber && !/^\d{10}$/.test(formData.PersonalMobileNumber)) {
        newErrors.PersonalMobileNumber = "Mobile number must be 10 digits";
      }

      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (formData.Personal_EmailID && !emailRegex.test(formData.Personal_EmailID)) {
        newErrors.Personal_EmailID = "Invalid personal email format";
      }
      if (formData.corporate_email_id && !emailRegex.test(formData.corporate_email_id)) {
        newErrors.corporate_email_id = "Invalid corporate email format";
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };


      const handleSave = async () => {
        if (!validateForm()) return;
        const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
        
        try {
          const res = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/add-personal-details`, {
            method: "POST", 
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`
            },
            body: JSON.stringify(formData)
          });
          const result = await res.json();
          if (res.status === 200 && result.status === "success" && formData.corporate_email_id) {
            return { success: true, email: formData.corporate_email_id };
          } else {
            if (res.status === 409) {
              setErrors(prev => ({
                ...prev,
                corporate_email_id: result.message || "Email already exists"
              }));
            }
            return { success: false, message: result.message || "Failed to save personal details.", status: res.status };
          }
        } catch (error) {
          console.error("Save error:", error);
          setErrors(prev => ({
            ...prev,
            corporate_email_id: "Internal server error."
          }));
          return { success: false, message: "Internal server error." };
        }
      };

    const handleUpdate = async () => {
      if (!validateForm()) return;
      const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/update-personal-details/${employeeId}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`
          },
          body: JSON.stringify(formData)
        });
        const result = await res.json();
        if (result.status !== "success") {
          console.error("Update failed:", result.message);
          return false;
        } else {
          return formData.corporate_email_id || true; 
        }
      } catch (error) {
        console.error("Update error:", error);
      }
    };
    
    const validatePersonal = () => {
      return validateForm(); 
    }
    useImperativeHandle(ref, () => ({
      validatePersonal,
      savePersonal: employeeId ? handleUpdate : handleSave
    }));

    const customInputSx = {
      borderRadius: "8px",
      backgroundColor: "transparent",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa"
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa !important"
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa !important"
      }
    };

    const customLabelSx = {
      fontSize: "16.5px",
      fontWeight: "bold",
      color: colors.grey[100],
      "&.Mui-focused": {
        color: colors.grey[100]
      },
      "&.MuiInputLabel-shrink": {
        color: colors.grey[100]
      }
    };

    return (
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Grid container spacing={3}>
          {allowedFields.map((key) => {
            const isRequired = requiredFields.includes(key);
            const labelText = `${key.replace(/_/g, " ")}${isRequired ? " *" : ""}`;

            return (
              <Grid item xs={12} sm={6} md={4} key={key}>
                {selectOptions[key] ? (
                  <FormControl fullWidth error={!!errors[key]}>
                    <InputLabel sx={customLabelSx}>{labelText}</InputLabel>
                    <Select
                      name={key}
                      value={selectOptions[key].includes(String(formData[key]).trim()) ? String(formData[key]).trim() : ""}
                      onChange={handleChange}
                      label={labelText}
                      sx={customInputSx}
                    >
                      {selectOptions[key].map(option => (
                        <MenuItem key={option} value={option}>{option}</MenuItem>
                      ))}
                    </Select>
                    {errors[key] && <p style={{ color: 'red', margin: '3px 14px 0', fontSize: '0.75rem' }}>{errors[key]}</p>}
                  </FormControl>
                ) : dateFields.includes(key) ? (
                  <DatePicker
                    label={labelText}
                    value={formData[key] ? new Date(formData[key]) : null}
                    onChange={(newDate) => handleDateChange(key, newDate)}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        variant: "outlined",
                        size: "medium",
                        label: labelText,
                        error: !!errors[key],
                        helperText: errors[key] || "",
                        InputProps: { sx: { ...customInputSx, minHeight: "56px", fontSize: "1rem" } },
                        InputLabelProps: { sx: customLabelSx },
                        sx: { width: "100%" }
                      }
                    }}
                  />
                ) : (
                  <TextField
                    fullWidth
                    label={labelText}
                    name={key}
                    value={formData[key] || ""}
                    onChange={handleChange}
                    variant="outlined"
                    size="medium"
                    error={!!errors[key]}
                    helperText={errors[key] || ""}
                    InputProps={{ sx: customInputSx }}
                    InputLabelProps={{ sx: customLabelSx }}
                  />
                )}
              </Grid>
            );
          })}
        </Grid>
      </LocalizationProvider>

    );
  });

  export default PersonalDetailsForm;
